import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiBookOpen, FiRefreshCw, FiExternalLink, FiCalendar, FiGlobe } from 'react-icons/fi';

const Header = ({ onRefresh, isRefreshing }) => {
  return (
    <header className="bg-black border-b border-gray-800 sticky top-0 z-20 shadow-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center py-4 md:h-20 gap-4">
          <div className="flex items-center space-x-3">
            <div className="bg-[#FF0000] p-2 rounded-lg text-white shadow-lg shadow-red-900/20">
              <SafeIcon icon={FiBookOpen} className="text-xl" />
            </div>
            <div>
              <h1 className="text-xl font-black text-white tracking-tighter uppercase">
                Dr. Lionel Maten
              </h1>
              <p className="text-[10px] text-[#FF0000] font-bold tracking-[0.2em] uppercase -mt-1">
                HigherEd Daily Insights
              </p>
            </div>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-3">
            <a 
              href="https://dr.lionelmaten.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-1.5 px-3 py-1.5 text-xs font-bold text-white hover:text-[#FF0000] transition-colors border border-gray-700 rounded-md"
            >
              <SafeIcon icon={FiGlobe} />
              <span>Personal Website</span>
            </a>
            <a 
              href="https://zcal.co/ligonroadllc/DrLM" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-1.5 px-3 py-1.5 text-xs font-bold bg-[#FF0000] text-white hover:bg-red-700 transition-colors rounded-md shadow-md"
            >
              <SafeIcon icon={FiCalendar} />
              <span>Schedule Appointment</span>
            </a>
            <div className="h-6 w-px bg-gray-700 mx-1 hidden sm:block"></div>
            <button 
              onClick={onRefresh} 
              disabled={isRefreshing} 
              className="flex items-center space-x-2 px-4 py-1.5 bg-white hover:bg-gray-100 text-black rounded-md transition-colors disabled:opacity-50 font-bold text-xs uppercase"
            >
              <SafeIcon icon={FiRefreshCw} className={`${isRefreshing ? 'animate-spin' : ''}`} />
              <span>{isRefreshing ? 'Syncing...' : 'Refresh'}</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;